<ng-template #iconItem let-item>
  <li
    class="sidebar-item-list"
    [class.active]="item.active"
    (mouseenter)="onItemEnter()"
    (mouseleave)="onItemLeave()"
  >
    @if (item.routerLink) {
      <a [routerLink]="item.routerLink" (click)="onItemClick(item)" class="h-16 flex items-center justify-center text-gray-900 rounded-lg dark:text-white sidebar-item relative">
        <ng-container *ngTemplateOutlet="iconContent; context: { $implicit: item }" />
      </a>
    } @else {
      <a [href]="item.href" class="h-16 flex items-center justify-center text-gray-900 rounded-lg dark:text-white sidebar-item relative">
        <ng-container *ngTemplateOutlet="iconContent; context: { $implicit: item }" />
      </a>
    }
  </li>
</ng-template>

<ng-template #iconContent let-item>
  <img [id]="item.id" [src]="item.icon" [alt]="item.alt" class="w-8 h-8 mx-5" />
  @if (item.badge && pendingSuggestionsCount > 0) {
    <span class="absolute top-2 right-3 flex items-center justify-center min-w-5 h-5 px-1 text-xs font-bold text-white bg-primary-purple-light rounded-full">
      {{ pendingBadge }}
    </span>
  }
</ng-template>

<ng-template #labelItem let-item>
  <li class="sidebar-submenu-item-list" [class.active]="item.active">
    @if (item.routerLink) {
      <a [routerLink]="item.routerLink" (click)="onItemClick(item)" class="h-16 flex items-center justify-left ml-5 font-bold text-lg text-gray-900 rounded-lg dark:text-white sidebar-item">
        <ng-container *ngTemplateOutlet="labelContent; context: { $implicit: item }" />
      </a>
    } @else {
      <a [href]="item.href" class="h-16 flex items-center justify-left ml-5 font-bold text-lg text-gray-900 rounded-lg dark:text-white sidebar-item">
        <ng-container *ngTemplateOutlet="labelContent; context: { $implicit: item }" />
      </a>
    }
  </li>
</ng-template>

<ng-template #labelContent let-item>
  <h1>{{ literalService.get(item.label, true) }}</h1>
  @if (item.badge && pendingSuggestionsCount > 0) {
    <span class="ml-2 flex items-center justify-center min-w-5 h-5 px-1 text-xs font-bold text-white bg-primary-purple-light rounded-full">
      {{ pendingBadge }}
    </span>
  }
</ng-template>

<!-- MENU -->
<aside
  id="sidebar"
  class="dark:sidebar fixed top-0 left-0 w-20 z-40 h-screen pt-0 transition-transform -translate-x-full border-gray-200 sm:translate-x-0 bg-white dark:bg-gray-800 dark:border-gray-700 overflow-hidden"  aria-label="Sidebar"
>
  <div class="h-full pb-4 overflow-y-auto dark:bg-gray-800 flex flex-col justify-between">
    <ul class="font-medium">
      <li class="h-20 flex">
        <a class="h-16 justify-center m-auto flex text-gray-900 rounded-lg dark:text-white">
          <img id="logoSection" [src]="images.logos.nemiSmall" alt="logo" class="w-12" />
        </a>
      </li>
      @if (isSuperAdmin()) {
        <li
          id="adminsSectionList"
          class="sidebar-item-list"
          [class.active]="superAdminZoneActive()"
          [class.submenu-hovered]="submenuHovered() || adminSubmenuHovered()"
          (mouseenter)="onAdminItemEnter()"
          (mouseleave)="onAdminItemLeave()"
          (click)="expandSuperAdminZone()"
        >
          <a class="h-16 flex items-center justify-center text-gray-900 rounded-lg dark:text-white sidebar-item cursor-pointer">
            <img id="adminsSection" [src]="images.sidebar.admin" alt="superadminZone" class="w-8 h-8 mx-5" />
          </a>
        </li>
      }
      @for (item of topItems(); track item.id) {
        <ng-container *ngTemplateOutlet="iconItem; context: { $implicit: item }" />
      }
    </ul>
    <ul class="font-medium">
      @for (item of bottomItems(); track item.id) {
        <ng-container *ngTemplateOutlet="iconItem; context: { $implicit: item }" />
      }
    </ul>
  </div>
</aside>
<!-- SUBMENU -->
<aside
  id="sidebar-submenu"
  class="fixed top-0 left-0 w-52 z-55 h-screen pt-0 transition-transform -translate-x-full border-gray-200 sm:translate-x-20 dark:bg-gray-800 dark:border-gray-700"
  [ngClass]="{ 'fadeOut': !submenuOpen(), 'fadeIn': submenuOpen(), 'visible': submenuShown() }"
  aria-label="Sidebar"
  (mouseenter)="onSubmenuEnter()"
  (mouseleave)="onSubmenuLeave()"
>
  <div class="h-full pb-4 overflow-y-auto dark:bg-gray-800 flex flex-col justify-between">
    <ul class="font-medium">
      <li class="h-20 flex">
        <a class="h-16 justify-center m-auto flex text-gray-900 rounded-lg dark:text-white">
          <img id="logoSubmenuSection" [src]="images.logos.nemiLarge" alt="logo" class="w-36" />
        </a>
      </li>
      @if (isSuperAdmin()) {
        <li
          id="adminsSubmenuSectionList"
          class="sidebar-submenu-item-list"
          [class.active]="superAdminZoneActive()"
          [class.submenu-admin-hovered]="adminSubmenuHovered()"
          (mouseenter)="onAdminSubmenuItemEnter()"
          (mouseleave)="onAdminSubmenuItemLeave()"
        >
          <a class="h-16 flex items-center justify-left ml-5 font-bold text-lg text-gray-900 rounded-lg dark:text-white sidebar-item">
            <h1>{{ literalService.get('sidebar.superadminZone', true) }}</h1>
          </a>
        </li>
      }
      @for (item of topItems(); track item.id) {
        <ng-container *ngTemplateOutlet="labelItem; context: { $implicit: item }" />
      }
    </ul>
    <ul class="font-medium">
      @for (item of bottomItems(); track item.id) {
        <ng-container *ngTemplateOutlet="labelItem; context: { $implicit: item }" />
      }
    </ul>
  </div>
</aside>
<!-- ADMINISTRATORS SUBMENU -->
<aside
  id="sidebar-submenu-admin"
  class="fixed top-20 left-0 h-auto w-60 z-60 pt-0 transition-transform -translate-x-full border-gray-200 sm:translate-x-72 dark:bg-gray-800 dark:border-gray-700"
  [ngClass]="{ 'fadeOut': !adminSubmenuOpen(), 'fadeIn': adminSubmenuOpen(), 'visible': adminSubmenuOpen() }"
  aria-label="Sidebar"
  (mouseenter)="onAdminSubmenuEnter()"
  (mouseleave)="onAdminSubmenuLeave()"
>
  <div class="h-full pb-4 overflow-y-auto dark:bg-gray-800">
    <ul class="font-medium">
      @for (item of adminItems; track item.label) {
        <li class="sidebar-submenu-admin-item-list" [class.active]="routeName() === item.routeName">
          <a [routerLink]="item.routerLink" class="h-14 flex items-center justify-left font-semibold text-base text-gray-900 rounded-lg dark:text-white sidebar-item" (click)="onAdminItemClick(item)">
            <img [src]="item.icon" [alt]="item.alt" [height]="item.height" [width]="item.width" />
            <h1 class="ml-4">{{ literalService.get(item.label, true) }}</h1>
          </a>
        </li>
        @if (!$last) {
          <li class="separator"></li>
        }
      }
    </ul>
  </div>
</aside>
